export default {
  color: window?.settings?.primary_color ?? '#1DBD6B',
  zIndex: 1,
  position: 'relative',
  pointerEvents: 'none',
  letterSpacing: '0px',
}
